function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { NavAction } from './Actions';
import { getOrganisationLogo } from './helper';
function HeaderDesktopWrapper(props) {
  const {
    logo,
    leftActions,
    rightActions,
    className
  } = props;
  const {
    svg,
    to,
    target = '_self',
    onClick = () => {},
    imageUrl
  } = logo || {};
  const onClickLink = e => {
    if (to === '#') {
      e.preventDefault();
      e.nativeEvent.stopImmediatePropagation();
    }
    onClick(e);
  };
  const headerClasses = classNames({
    'sib-header': true,
    [className]: !!className
  });
  return /*#__PURE__*/React.createElement("header", {
    className: headerClasses
  }, logo ? /*#__PURE__*/React.createElement("a", {
    href: to,
    target: target,
    onClick: onClickLink,
    className: "sib-header__organization",
    rel: "home",
    "aria-label": "logo"
  }, getOrganisationLogo({
    imageUrl,
    svg
  })) : null, /*#__PURE__*/React.createElement("nav", {
    className: "sib-navbar"
  }, leftActions ? /*#__PURE__*/React.createElement("ul", {
    className: "sib-navbar__left-actions"
  }, leftActions.map((action, index) => {
    return /*#__PURE__*/React.createElement(NavAction, _extends({
      key: index
    }, action));
  })) : null, rightActions ? /*#__PURE__*/React.createElement("ul", {
    className: "sib-navbar__right-actions"
  }, rightActions.map((action, index) => {
    return /*#__PURE__*/React.createElement(NavAction, _extends({
      key: index
    }, action));
  })) : null));
}
HeaderDesktopWrapper.defaultProps = {
  logo: null,
  leftActions: null,
  rightActions: null,
  className: ''
};
HeaderDesktopWrapper.propTypes = {
  logo: PropTypes.object,
  leftActions: PropTypes.array,
  rightActions: PropTypes.array,
  className: PropTypes.string
};
export default HeaderDesktopWrapper;